import { render } from "./InvoiceTabPaymentHistory.vue?vue&type=template&id=38c12a2a"
import script from "./InvoiceTabPaymentHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceTabPaymentHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__